import Modal from '../../DesignSystem/Modal';
import s from './MapModal.module.scss';
import GoogleMap from '../GoogleMap';
import Navbar from '../../DesignSystem/Navbar';
import { useEffect, useState } from 'react';
const MapModal = ({ show, onClose, onConfirm, initialLat, initialLng }) => {
  console.log('values', initialLat, initialLng);
  const [initialCoords, setInitialCoords] = useState(null);

  useEffect(() => {
    if (show) {
      if (initialLat && initialLng) {
        setInitialCoords({ lat: initialLat, lng: initialLng });
      } else {
        navigator.geolocation.getCurrentPosition((position) => {
          setInitialCoords({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      }
    }
  }, [show, initialLat, initialLng]);
  return (
    <Modal isOpen={show}>
      <div className={s.root}>
        <Navbar onBack={onClose} label="Search Address" />
        <div className={s.mapWrapper}>
          <GoogleMap onConfirm={onConfirm} initialCoords={initialCoords} />
        </div>
      </div>
    </Modal>
  );
};

export default MapModal;
